//
import COMMUTE1 from "./Figures-cutline_COMMUTE-1.png";
import COMMUTE2 from "./Figures-cutline_COMMUTE-2.png";
import COMMUTE3 from "./Figures-cutline_COMMUTE-3.png";
import DESIGN1 from "./Figures-cutline_DESIGN-1.png";
import DESIGN2 from "./Figures-cutline_DESIGN-2.png";
import DESIGN3 from "./Figures-cutline_DESIGN-3.png";
import DISPLAY1 from "./Figures-cutline_DISPLAY-1.png";
import DISPLAY2 from "./Figures-cutline_DISPLAY-2.png";
import DISPLAY3 from "./Figures-cutline_DISPLAY-3.png";
import EAT1 from "./Figures-cutline_EAT-1.png";
import EAT2 from "./Figures-cutline_EAT-2.png";
import EAT3 from "./Figures-cutline_EAT-3.png";
import HEAL1 from "./Figures-cutline_HEAL-1.png";
import HEAL2 from "./Figures-cutline_HEAL-2.png";
import HEAL3 from "./Figures-cutline_HEAL-3.png";
import MAKE1 from "./Figures-cutline_MAKE-1.png";
import MAKE2 from "./Figures-cutline_MAKE-2.png";
import MAKE3 from "./Figures-cutline_MAKE-3.png";
import PLANT1 from "./Figures-cutline_PLANT-1.png";
import PLANT2 from "./Figures-cutline_PLANT-2.png";
import PLANT3 from "./Figures-cutline_PLANT-3.png";
import READ1 from "./Figures-cutline_READ-1.png";
import READ2 from "./Figures-cutline_READ-2.png";
import READ3 from "./Figures-cutline_READ-3.png";
import SHOP1 from "./Figures-cutline_SHOP-1.png";
import SHOP2 from "./Figures-cutline_SHOP-2.png";
import SHOP3 from "./Figures-cutline_SHOP-3.png";
import SLEEP1 from "./Figures-cutline_SLEEP-1.png";
import SLEEP2 from "./Figures-cutline_SLEEP-2.png";
import SLEEP3 from "./Figures-cutline_SLEEP-3.png";
//
import webpCOMMUTE1 from "./Figures-cutline_COMMUTE-1.png?as=w";
import webpCOMMUTE2 from "./Figures-cutline_COMMUTE-2.png?as=w";
import webpCOMMUTE3 from "./Figures-cutline_COMMUTE-3.png?as=w";
import webpDESIGN1 from "./Figures-cutline_DESIGN-1.png?as=w";
import webpDESIGN2 from "./Figures-cutline_DESIGN-2.png?as=w";
import webpDESIGN3 from "./Figures-cutline_DESIGN-3.png?as=w";
import webpDISPLAY1 from "./Figures-cutline_DISPLAY-1.png?as=w";
import webpDISPLAY2 from "./Figures-cutline_DISPLAY-2.png?as=w";
import webpDISPLAY3 from "./Figures-cutline_DISPLAY-3.png?as=w";
import webpEAT1 from "./Figures-cutline_EAT-1.png?as=w";
import webpEAT2 from "./Figures-cutline_EAT-2.png?as=w";
import webpEAT3 from "./Figures-cutline_EAT-3.png?as=w";
import webpHEAL1 from "./Figures-cutline_HEAL-1.png?as=w";
import webpHEAL2 from "./Figures-cutline_HEAL-2.png?as=w";
import webpHEAL3 from "./Figures-cutline_HEAL-3.png?as=w";
import webpMAKE1 from "./Figures-cutline_MAKE-1.png?as=w";
import webpMAKE2 from "./Figures-cutline_MAKE-2.png?as=w";
import webpMAKE3 from "./Figures-cutline_MAKE-3.png?as=w";
import webpPLANT1 from "./Figures-cutline_PLANT-1.png?as=w";
import webpPLANT2 from "./Figures-cutline_PLANT-2.png?as=w";
import webpPLANT3 from "./Figures-cutline_PLANT-3.png?as=w";
import webpREAD1 from "./Figures-cutline_READ-1.png?as=w";
import webpREAD2 from "./Figures-cutline_READ-2.png?as=w";
import webpREAD3 from "./Figures-cutline_READ-3.png?as=w";
import webpSHOP1 from "./Figures-cutline_SHOP-1.png?as=w";
import webpSHOP2 from "./Figures-cutline_SHOP-2.png?as=w";
import webpSHOP3 from "./Figures-cutline_SHOP-3.png?as=w";
import webpSLEEP1 from "./Figures-cutline_SLEEP-1.png?as=w";
import webpSLEEP2 from "./Figures-cutline_SLEEP-2.png?as=w";
import webpSLEEP3 from "./Figures-cutline_SLEEP-3.png?as=w";
//
import allShowCaseNameImg from "./showcasename/Img";
//
import SUPPORTED from "./LOGOS-Supported-by.png";
import ORGANISED from "./LOGOS2-Organised-by.png";
import PARTOF from "./LOGOS3-Part-of.png";
import HELDIN from "./LOGOS4-Held-in.png";
import webpSUPPORTED from "./LOGOS-Supported-by.png?as=w";
import webpORGANISED from "./LOGOS2-Organised-by.png?as=w";
import webpPARTOF from "./LOGOS3-Part-of.png?as=w";
import webpHELDIN from "./LOGOS4-Held-in.png?as=w";

export const allImgs = {
  COMMUTE1,
  COMMUTE2,
  COMMUTE3,
  DESIGN1,
  DESIGN2,
  DESIGN3,
  DISPLAY1,
  DISPLAY2,
  DISPLAY3,
  EAT1,
  EAT2,
  EAT3,
  HEAL1,
  HEAL2,
  HEAL3,
  MAKE1,
  MAKE2,
  MAKE3,
  PLANT1,
  PLANT2,
  PLANT3,
  READ1,
  READ2,
  READ3,
  SHOP1,
  SHOP2,
  SHOP3,
  SLEEP1,
  SLEEP2,
  SLEEP3,
};

const allImg = {
  ...allImgs,
  webpSUPPORTED,
  webpORGANISED,
  webpPARTOF,
  webpHELDIN,
  SUPPORTED,
  ORGANISED,
  PARTOF,
  HELDIN,
  webpCOMMUTE1,
  webpCOMMUTE2,
  webpCOMMUTE3,
  webpDESIGN1,
  webpDESIGN2,
  webpDESIGN3,
  webpDISPLAY1,
  webpDISPLAY2,
  webpDISPLAY3,
  webpEAT1,
  webpEAT2,
  webpEAT3,
  webpHEAL1,
  webpHEAL2,
  webpHEAL3,
  webpMAKE1,
  webpMAKE2,
  webpMAKE3,
  webpPLANT1,
  webpPLANT2,
  webpPLANT3,
  webpREAD1,
  webpREAD2,
  webpREAD3,
  webpSHOP1,
  webpSHOP2,
  webpSHOP3,
  webpSLEEP1,
  webpSLEEP2,
  webpSLEEP3,
};

const Img = ({ src, alt = "image", className = "" }) => {
  return src in allImg ? (
    <picture className={className}>
      <source srcSet={allImg[`webp${src}`]} type="image/webp" />
      <source srcSet={allImg[src]} type="image/jpeg" />
      <img src={allImg[src]} alt={alt} />
    </picture>
  ) : (
    ""
  );
};

export const ImgShowcaseName = ({ src, alt = "image", className = "" }) => {
  return src in allShowCaseNameImg ? (
    <picture className={className}>
      <source srcSet={allShowCaseNameImg[`webp${src}`]} type="image/webp" />
      <source srcSet={allShowCaseNameImg[src]} type="image/jpeg" />
      <img src={allShowCaseNameImg[src]} alt={alt} />
    </picture>
  ) : (
    ""
  );
};
// REACT_APP_ISDEV
export default Img;
